import FoodCategory from '@components/offer/models/FoodCategory';
import { ButtonBase } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface FoodCategoryBaseButtonProps {
    foodCategory: FoodCategory;
    children: React.ReactNode;
    onClick: (foodCategory: FoodCategory) => void
}

const FoodCategoryBaseButton: React.FC<FoodCategoryBaseButtonProps> = observer(({ children, foodCategory, onClick }) => {
    return (
        <ButtonBase
            onClick={() => onClick(foodCategory)}
            sx={(theme) => ({
                boxShadow: foodCategory.isSelected ? theme.shadows[10] : theme.shadows[9],
                backgroundColor: foodCategory.isSelected ? theme.palette.secondary.light : "Background"
            })}>
            {children}
        </ButtonBase>
    )
})

export default FoodCategoryBaseButton;